@if(!isDataReady){
    <p-skeleton styleClass="mb-2" />
    <p-skeleton styleClass="mb-2" />
    
    <p-skeleton width="75%" styleClass="mb-2" />
    <p-skeleton width="75%" styleClass="mb-2" />
}
@else{

<!-- No Data Skills and Experience -->
<div class="flex flex-column justify-content-center align-items-center h-page-full" *ngIf="false">
    <div class="flex flex-column gap-1 h5 text-center">
        <span>You don't have any education experience entered.</span>
        <span>{{'Please Add experience' | sentenceCase}}</span>
    </div>
</div>
<!-- No Data Skills and Experience  End-->

<!-- Create Skills and Experience -->
<div class="flex flex-column justify-content-between">
    <div class="grid w-full">
        @for (scl of skillsCriteriaListing; track scl;let i = $index) {
            <div class="col-12 pb-5">
                <p class="mt-0 mb-2 text-lg font-normal">{{scl.name}} <span class="text-sm">{{scl.description}}</span></p>
                <p-floatLabel>
                    <p-multiSelect [(ngModel)]="scl.criteriaSelectedOption" [options]="scl.label.values" optionLabel="val" inputId="reviewExperience"
                        appendTo="body" placeholder="Select all that apply" [resetFilterOnHide]="true"/>
                    <label for="reviewExperience">Select all that apply</label>
                </p-floatLabel>
                @if(scl.criteriaSelectedOption.length > 0){
                <div class="flex align-items-center gap-2 flex-wrap pt-2">
                    @for (options of scl.criteriaSelectedOption; track options) {
                        <div class="flex align-items-center gap-2 flex-wrap">
                            <p-chip [label]="options.val" (onRemove)="onRemoveChip(options,i)" [removable]="true" />
                            @if(options.isExperienceEnabled){
                                <p-dropdown [options]="scl.experienceLevels" optionLabel="experience" [(ngModel)]="options.selectedExperienceLevel"
                                (onChange)="onExperienceLevelChange(scl, options)"
                                [class.ng-invalid]="hasExperienceLevelError(scl, options)" [class.ng-dirty]="hasExperienceLevelError(scl, options)"
                                appendTo="body" placeholder="Select experience level"/>
                                @if(hasExperienceLevelError(scl, options)){
                                    <div class="p-error">This field is required</div>
                                }
                            }
                        </div>
                    }
                </div>
                }
            </div>
        }
    </div>
    <div class="flex gap-3 mt-3">
        <p-button label="back" rounded="true" outlined="true" size="large"
            styleClass="white-space-nowrap" (onClick)="onDiscard(false)"></p-button>
        <p-button (onClick)="save()" label="save" rounded="true" size="large" styleClass="white-space-nowrap freshgreen-background"></p-button>
    </div>
</div>
<!-- Create Skills and Experience End-->
}
